import { BodyText, Flex, IconV2, Link } from '@bamboohr/fabric';

export const PasskeyFacts: React.FC<{
	hasMaxWidth?: boolean;
	showLearnMore?: boolean;
	bodyToBulletGap?: number;
	bulletPointGap?: number;
}> = ({
	hasMaxWidth = false,
	showLearnMore = false,
	bodyToBulletGap = 2,
	bulletPointGap = 1,
}) => {
	return (
		<Flex
			flexDirection="column"
			gap={bodyToBulletGap}
			maxWidth={hasMaxWidth ? 436 : undefined}
		>
			<BodyText size="medium">
				{$.__('Passkeys let you log in without a password.')}{' '}
				{$.__(
					'They use your device’s built-in security to log in with your fingerprint, face, or PIN.',
				)}{' '}
				{showLearnMore && (
					<Link href="https://fidoalliance.org/passkeys/" target="_blank">
						{$.__('Learn more')}
					</Link>
				)}
			</BodyText>
			<Flex component="ul" flexDirection="column" gap={bulletPointGap}>
				<Flex alignItems="center" component="li" gap={1}>
					<IconV2 color="primary-strong" name="fingerprint-solid" size={16} />
					<BodyText size="medium" weight="medium">
						{$.__('More secure than passwords')}
					</BodyText>
				</Flex>
				<Flex alignItems="center" component="li" gap={1}>
					<IconV2 color="primary-strong" name="check-solid" size={16} />
					<BodyText size="medium" weight="medium">
						{$.__('Easy setup')}
					</BodyText>
				</Flex>
				<Flex alignItems="center" component="li" gap={1}>
					<IconV2
						color="primary-strong"
						name="rabbit-running-solid"
						size={16}
					/>
					<BodyText size="medium" weight="medium">
						{$.__('Faster sign-in')}
					</BodyText>
				</Flex>
			</Flex>
		</Flex>
	);
};
